import { Query } from '../query.builder';

export abstract class QueryRepository<T> {

  protected abstract api: string;

  constructor() { }

  async load(query: Query): Promise<{data: Partial<T[]>, pivotFields?: string[]}> {
    const response = await fetch(
      this.api, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Basic cXVlcnk6RFVFdVVWdmNSaXR1ODUxbUx3S2I='
        }),
        body: JSON.stringify(query)
      })

    if(!response.ok)
      throw new Error('Unable to load Data');
    const data = await response.json()
    return data;
  }

}
